import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../helpers/reselectHelpers';
import {CalendarVersionModel} from '../../../models/api/calendarVersionModel';
import {getWriteAccessCalendarVersions} from '../../../store/data/calendarVersions/calendarVersionsSelectors';
import {getCalendars} from '../../../store/data/dataSelectors';
import {CalendarDropdownBox} from './calendarDropdownBox';

/*
 * Props.
 */

interface CalendarDropdownBoxContainerProps {
  selectedCalendarVersion: CalendarVersionModel;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<CalendarDropdownBoxContainerProps>()(() => ({
  calendars: getCalendars,
  calendarVersions: getWriteAccessCalendarVersions,
}));

export const CalendarDropdownBoxContainer = connect(mapStateToProps)(CalendarDropdownBox);
